import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import useGrowthOffers, { referralOpen } from "../../hooks/useGrowthOffers";

/* After an order, the invite: only when the server has invites switched on. */
const InviteNudge = () => {
  const offers = useGrowthOffers();
  if (!referralOpen(offers)) return null;
  return (
    <Nudge>
      <span>
        <strong>Give a friend their first delivery free.</strong> You get a free
        delivery when their order arrives.
      </span>
      <Link to="/my_profile/invite_friends">Invite</Link>
    </Nudge>
  );
};

const Nudge = styled.div`
  margin-top: 16px;
  padding: 16px 18px;
  border-radius: 14px;
  border: 1px solid #e1e6de;
  background: #ffffff;
  color: #15232a;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  font-size: 14px;
  line-height: 1.45;

  a {
    min-height: 44px;
    display: inline-flex;
    align-items: center;
    padding: 0 18px;
    border-radius: 12px;
    background: #3d6a0b;
    color: #ffffff;
    font-weight: 800;
    text-decoration: none;
  }
`;

export default InviteNudge;
